(() => {
  const english = document.documentElement.lang.toLowerCase().startsWith('en');
  const currentPathWithoutLocale =
    window.location.pathname.replace(/^\/en(?=\/|$)/, '') || '/';

  const updateLanguageLinks = () => {
    document
      .querySelectorAll('.localization-language-links__item[lang]')
      .forEach((link) => {
        const language = link.getAttribute('lang').toLowerCase();
        const localizedPath =
          language === 'en'
            ? `/en${currentPathWithoutLocale === '/' ? '' : currentPathWithoutLocale}`
            : currentPathWithoutLocale;

        link.href = `${localizedPath}${window.location.search}${window.location.hash}`;
      });
  };

  updateLanguageLinks();

  if (!english) return;

  const translations = new Map([
    ['GYŰRŰTERVEZŐ', 'DESIGN YOUR RING'],
    ['Gyűrűtervező', 'Design Your Ring'],
    ['TERMÉSZETES GYÉMÁNTOK', 'NATURAL DIAMONDS'],
    ['Természetes gyémántok', 'Natural Diamonds'],
    ['IDŐPONTFOGLALÁS', 'BOOK AN APPOINTMENT'],
    ['Időpontfoglalás', 'Book an Appointment'],
    ['KAPCSOLAT', 'CONTACT'],
    ['GYÉMÁNTOK', 'DIAMONDS'],
    ['Gyémántok', 'Diamonds'],
    ['Tervezek', 'DESIGN YOUR RING'],
    ['Keresek', 'BROWSE DIAMONDS'],
    ['MEGNÉZEM', 'VIEW'],
    ['Megnézem', 'View'],
    [
      'Egyedileg tervezett arany eljegyzési gyűrűk GIA-minősítésű természetes gyémántokkal,',
      'Bespoke gold engagement rings set with GIA-certified natural diamonds,',
    ],
    [
      'több százezer választható kőből.',
      'with hundreds of thousands of stones to choose from.',
    ],
    [
      'Egyedileg tervezett arany eljegyzési gyűrűk GIA-minősítésű természetes gyémántokkal, több százezer választható kőből.',
      'Bespoke gold engagement rings set with GIA-certified natural diamonds, with hundreds of thousands of stones to choose from.',
    ],
    [
      'Bemutatótermünkben személyesen segítünk megtervezni a tökéletes eljegyzési gyűrűdet.',
      'Visit our showroom, where we will personally help you design the perfect engagement ring.',
    ],
    [
      '"Amikor valaki természetes gyémántot választ, általában egy fontos pillanatra készül. Több mint húsz éve vagyok ennek a világnak a része, és számomra ma is az a legfontosabb, hogy aki hozzánk fordul, pontosan értse, mit választ, és biztos legyen a döntésében."',
      '"When someone chooses a natural diamond, they are usually preparing for an important moment. I have been part of this world for more than twenty years, and what matters most to me is that everyone who turns to us fully understands their choice and feels confident in their decision."',
    ],
    ['Hercsik Anita, az IDIA alapítója', 'Anita Hercsik, Founder of IDIA'],
    ['Gyakran ismételt kérdések', 'Frequently Asked Questions'],
    [
      'Hogyan válasszak eljegyzési gyűrűt?',
      'How should I choose an engagement ring?',
    ],
    [
      'Mennyibe kerül egy eljegyzési gyűrű természetes gyémánttal?',
      'How much does a natural diamond engagement ring cost?',
    ],
    ['Milyen gyémántot érdemes választani?', 'Which diamond should I choose?'],
    [
      'Mi a különbség a természetes és a laboratóriumban növesztett gyémánt között?',
      'What is the difference between a natural and a laboratory-grown diamond?',
    ],
    [
      'Mi történik, ha nem tudom a gyűrűméretet?',
      'What if I do not know the ring size?',
    ],
    [
      'Sokan úgy érkeznek hozzánk, hogy nem tudják, hol érdemes elkezdeni. Elsőként mindig arról beszélgetünk, milyen stílust szeret a párja. Letisztult, klasszikus vagy inkább különleges ékszereket visel? Ezután közösen kiválasztjuk a hozzá illő gyémántot és a foglalatot. Nem az a cél, hogy a legnagyobb követ válassza, hanem hogy olyan gyűrű készüljön, amelyet évek múlva is ugyanolyan örömmel visel majd.',
      'Many clients come to us unsure where to begin. We first discuss the style their partner loves: understated, classic or something more distinctive. We then choose the right diamond and setting together. The goal is not simply to select the largest stone, but to create a ring they will still love wearing many years from now.',
    ],
    [
      'Erre nincs egyetlen válasz, mert minden gyémánt más. Az árat a gyémánt mérete, csiszolása, színe és tisztasága határozza meg. Emellett a választott nemesfém és a foglalat kialakítása is befolyásolja a végösszeget. A rendelkezésre álló keretből mindig igyekszünk a lehető legszebb gyémántot megtalálni, és olyan gyűrűt összeállítani, amely hosszú távon is örömet okoz.',
      'There is no single answer because every diamond is unique. Its price is determined by its size, cut, colour and clarity, while the chosen precious metal and setting also affect the final cost. We always aim to find the most beautiful diamond within your budget and create a ring that will bring lasting joy.',
    ],
    [
      'Erre nincs általános válasz. Van, akinek a méret a legfontosabb, másnak a ragyogás vagy éppen a szín. A tapasztalatunk mégis azt mutatja, hogy a legszebb gyémánt nem mindig a legdrágább. Egy kiváló csiszolású kő gyakran sokkal élénkebben ragyog, mint egy nagyobb, de kevésbé arányos gyémánt. Éppen ezért minden választásnál azt nézzük, hogy az adott költségkeretből melyik gyémánt mutat a legszebben.',
      'There is no universal answer. For some, size matters most; for others, brilliance or colour is the priority. Our experience shows that the most beautiful diamond is not always the most expensive. An exceptionally well-cut stone often sparkles more vividly than a larger but less balanced diamond, so we focus on finding the stone that looks its best within your budget.',
    ],
    [
      'Mindkettő valódi gyémánt, ugyanazzal a fizikai összetétellel és tulajdonságokkal. A különbség az eredetükben van. A természetes gyémánt évmilliárdok alatt alakult ki a föld mélyén, míg a laboratóriumi gyémántot néhány hét alatt hozzák létre. Az IDIA kizárólag nemzetközi tanúsítvánnyal rendelkező természetes gyémántokkal foglalkozik. Számunkra ezek értékét nemcsak a szépségük, hanem a ritkaságuk és a természetes eredetük is adja.',
      'Both are real diamonds with the same physical composition and properties. The difference lies in their origin. A natural diamond forms deep within the Earth over billions of years, while a laboratory-grown diamond is created in a matter of weeks. IDIA works exclusively with internationally certified natural diamonds, whose value lies not only in their beauty but also in their rarity and natural origin.',
    ],
    [
      'Ez az egyik leggyakoribb kérdés, és szerencsére könnyen megoldható. Ha van a párjának olyan gyűrűje, amelyet azon az ujján visel, amelyre az eljegyzési gyűrű is kerül majd, abból általában pontosan meg tudjuk állapítani a méretet. Ha pedig elsőre mégsem sikerül eltalálni, nincs ok az aggodalomra. A legtöbb általunk készített gyűrű mérete utólag is biztonságosan módosítható.',
      'This is one of the most common questions and, fortunately, it is usually easy to solve. If your partner has a ring worn on the same finger as the future engagement ring, we can normally determine the size accurately from it. If the first estimate is not perfect, there is no need to worry: most rings we create can be resized safely afterwards.',
    ],
    ['RÓLUNK', 'ABOUT US'],
    ['MAGAZIN', 'JOURNAL'],
    ['INFORMÁCIÓK', 'INFORMATION'],
    ['RENDELÉS ÉS SZÁLLÍTÁS', 'ORDERS AND DELIVERY'],
    ['PANASZKEZELÉS ÉS ELÁLLÁS', 'COMPLAINTS AND RETURNS'],
    ['ADATVÉDELEM', 'PRIVACY POLICY'],
    ['ÁSZF', 'TERMS AND CONDITIONS'],
    ['IMPRESSZUM', 'LEGAL NOTICE'],
    ['Csatlakozz az IDIA közösségéhez!', 'Join the IDIA community!'],
    [
      'Értesülj elsőként újdonságainkról és exkluzív ajánlatainkról.',
      'Be the first to discover our latest arrivals and exclusive offers.',
    ],
    ['Bemutatóterem', 'Showroom'],
    ['Kapcsolat', 'Contact'],
    ['III. emelet 301.', '3rd floor, suite 301'],
    [
      'Bemutatótermünk előzetes időpontfoglalással látogatható. Időpontot az „Időpontfoglalás” menüben foglalhatsz, vagy egyeztess velünk telefonon, e-mailben, hogy a számodra legmegfelelőbb időpontban fogadhassunk.',
      'Our showroom is open by appointment. Book through the “Book an appointment” menu, or contact us by phone or email so we can welcome you at the most convenient time.',
    ],
    ['Kérdésed van? Írj nekünk!', 'Have a question? Send us a message!'],
  ]);

  const normalize = (value) => value.replace(/\s+/g, ' ').trim();

  const translateTextNode = (node) => {
    const normalized = normalize(node.nodeValue || '');
    const translated = translations.get(normalized);
    if (!translated) return;

    const leading = node.nodeValue.match(/^\s*/)?.[0] || '';
    const trailing = node.nodeValue.match(/\s*$/)?.[0] || '';
    node.nodeValue = `${leading}${translated}${trailing}`;
  };

  const translateSubtree = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }

    if (!(root instanceof Element) && root !== document.body) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) translateTextNode(node);
  };

  const localizeInternalLinks = (root = document) => {
    root.querySelectorAll?.('a[href^="/"]').forEach((link) => {
      if (link.matches('.localization-language-links__item')) return;
      const url = new URL(link.href, window.location.origin);
      if (!url.pathname.startsWith('/en/') && url.pathname !== '/en') {
        url.pathname = `/en${url.pathname === '/' ? '' : url.pathname}`;
        link.href = `${url.pathname}${url.search}${url.hash}`;
      }
    });
  };

  const localizePage = () => {
    translateSubtree(document.body);
    localizeInternalLinks();
    updateLanguageLinks();
  };

  localizePage();
  window.setTimeout(localizePage, 250);
  window.setTimeout(localizePage, 1000);
  window.setTimeout(localizePage, 2500);

  if (document.title === 'idia.hu természetes gyémánt online katalógus – IDIA Kft') {
    document.title = 'IDIA Natural Diamond Jewellery and Ring Builder';
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        translateSubtree(node);
        if (node instanceof Element) localizeInternalLinks(node);
      });
    });
    updateLanguageLinks();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
